import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["attrs", "remark"];
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Icon, Toast } from 'zarm';
import { getLocalClick } from '@/components/EventBtn/handleEvent';
import Content from '@/components/Content';
import { FormItem } from '@/baseComponents';
import session, { FILES } from '@/store/session';
import { getQueryParam } from '@/utils/tool'; // import history from '@/history';

import { useFixedUI } from '@/hooks/index.js';
import './index.less';
import { getState } from '@/store';

const getElement = (attribute, element) => {
  const fn = (curr = element) => {
    if (!curr) {
      return;
    }

    const {
      parentElement
    } = curr;
    const useful = curr.hasAttribute(attribute);
    return useful ? curr : fn(parentElement);
  };

  return fn();
};

const getAttribute = (attribute, element) => {
  const curr = getElement(attribute, element);

  if (!curr) {
    return;
  }

  return curr.getAttribute(attribute);
};

const validateChecked = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    Toast.show({
      className: 'test',
      content: '请勾选页面底部条款',
      mask: true
    }); // callback();
  }
};

const ClauseChecked = props => {
  const {
    onChange,
    value = 0
  } = props;
  const [checked, setChecked] = useState(0);
  useEffect(() => {
    setChecked(value);
  }, [value]);
  const checkCls = classnames({
    'clause-ele': true,
    checked
  });

  const onClick = () => {
    const val = checked === 0 ? 1 : 0;
    onChange(val);
    setChecked(val);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: checkCls,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon",
    type: "right"
  }));
}; // 通过DateKey生成提取数据的正则


const getReg = dataKey => {
  const regStr = `${dataKey}="(.+?)">`;
  return new RegExp(regStr, 'g');
}; // 提取所有符合条件的内容 返回生产的数组


const getExecStrs = (str, dataKey) => {
  try {
    const reg = getReg(dataKey);
    const list = [];
    let result = null;

    do {
      result = reg.exec(str);
      result && list.push(result[1]);
    } while (result);

    return list;
  } catch (error) {
    console.log('error: ', error);
  }
};

const getDataFiles = (list = []) => {
  return list.map(i => {
    return JSON.parse(window.decodeURIComponent(i));
  });
};

const Clause = /*#__PURE__*/React.forwardRef((props = {}) => {
  const myref = useRef();
  useFixedUI(myref);

  const {
    attrs,
    remark
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    className,
    confirm = false,
    content = '',
    clause = [] // 保险条款

  } = attrs;
  const cls = classnames({
    'components-clause-render': true,
    [className]: !!className
  });

  const renderCheck = () => {
    if (!confirm) {
      return null;
    }

    const formItemProps = {
      name: 'clause.checked',
      fieldOption: {
        rules: [{
          validator: validateChecked
        }]
      }
    };
    return /*#__PURE__*/React.createElement(FormItem, _extends({
      noStyle: true
    }, formItemProps), /*#__PURE__*/React.createElement(ClauseChecked, null));
  };

  const getProductExemption = (list = []) => {
    return list.some(item => item.holderExemptionInsurance === 'Y');
  }; // 获取产品层级“是否投保人豁免险”标识


  const getHolderExemption = () => {
    const plan = getState('insurancePlan');
    let exemption = false;

    if (plan !== null && plan !== void 0 && plan.planConfigPackageList) {
      exemption = plan.planConfigPackageList.some(item => getProductExemption(item.planConfigProductList));
    } else if (plan !== null && plan !== void 0 && plan.planConfigProductList) {
      exemption = getProductExemption(plan.planConfigProductList);
    }

    return exemption;
  }; // 重置内容，当产品层级“是否投保人豁免险”标识为否，而投保流程中文件被标识为“投保人豁免" 时隐藏文件


  const transformContent = (content = '') => {
    const _list = getExecStrs(content, 'data-file-object');

    const list = getDataFiles(_list);
    const exemption = getHolderExemption();
    list.forEach((item, index) => {
      if (item.isExemption && !exemption) {
        const str = `data-file-object="${_list[index]}"`;
        content = content.replace(str, 'style=display:none');
      }
    });
    return content;
  };

  const renderText = () => {
    const dangerouslySetInnerHTML = {
      __html: transformContent(content)
    };

    const onClick = e => {
      const {
        target
      } = e;
      const hadClause = getElement('data-clause', target); // console.log('hadClause: ', hadClause);

      if (hadClause) {
        const items = clause.map((item = {}, index) => {
          const {
            from,
            tenantFrom
          } = getQueryParam();
          const qFrom = tenantFrom || from || '';
          const {
            title,
            url = '',
            name = ''
          } = item;
          const link = url && url.replace(/^http:/, 'https:');
          let href = '';

          if (qFrom === 'ba') {
            href = url;
          } else {
            href = url.includes('pdf') ? `https://cdn-health.zhongan.com/pdf/index.html?path=${encodeURIComponent(link)}&title=${name}` : url;
          }

          return /*#__PURE__*/React.createElement("a", {
            className: "clause-item",
            target: "_blank",
            href: href,
            key: index,
            rel: "noreferrer"
          }, title);
        });
        session.set(FILES, items); // Modal.hide();
        // history.push('/healthfiles');
      }

      const pageId = getAttribute('data-page-id', target);
      const moduleId = getAttribute('data-module-id', target);
      const tabIndex = getAttribute('data-tab-index', target); // console.log('pageId: ', pageId, 'moduleId: ', moduleId, 'tabIndex: ', tabIndex);

      if (pageId || moduleId || tabIndex) {
        const opts = {
          type: 'page',
          page: [pageId, moduleId, tabIndex]
        };
        getLocalClick(opts)();
      }
    };

    return /*#__PURE__*/React.createElement(Content, {
      className: "clause-text",
      dangerouslySetInnerHTML: dangerouslySetInnerHTML,
      onClick: onClick
    });
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: myref
  }, others), renderCheck(), renderText());
});
export default Clause;